export default "__VITE_ASSET__BGSvXxHK__"